const sections = document.querySelectorAll('.Layout__wrap .Section');
if ('IntersectionObserver' in window) {
	const sectionObserver = new IntersectionObserver(
		(sections) => {
			sections.forEach((section) => {
				const target = section.target;
				target.classList[section.isIntersecting ? 'add' : 'remove']('Section--inview');
				if (section.isIntersecting) {
					target.classList.add('Section--seen');
				}
			});
		},
		{ threshold: 0.25 }
	);
	sections.forEach((section) => {
		section.classList.add('Section--active');
		sectionObserver.observe(section);
	});
} else {
	sections.forEach((section) =>
		section.classList.add('Section--inview', 'Section--seen')
	);
}
export default {};
